import React from 'react'

import { Icon, IconProps } from '@chakra-ui/react'

export const TabIcon: React.FC<IconProps> = (props) => {
  return (
    <Icon
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 20 19"
      fill="none"
      {...props}
    >
      <path
        d="M20 4.0155C20 1.88002 18.2645 0.144531 16.129 0.144531H3.87097C1.73548 0.144531 0 1.88002 0 4.0155V14.3381C0 16.4736 1.73548 18.209 3.87097 18.209H16.129C18.2645 18.209 20 16.4736 20 14.3381V4.0155ZM18.0645 14.3381C18.0645 15.4058 17.1968 16.2736 16.129 16.2736H3.87097C2.80323 16.2736 1.93548 15.4058 1.93548 14.3381V4.0155C1.93548 2.94776 2.80323 2.08002 3.87097 2.08002H5.53548L6.99355 5.48324C7.45161 6.55098 8.5 7.24131 9.66129 7.24131H18.0613V14.3381H18.0645ZM18.0645 5.30582H9.66452C9.27742 5.30582 8.92903 5.07679 8.77419 4.71872L7.64193 2.08002H16.129C17.1968 2.08002 18.0645 2.94776 18.0645 4.0155V5.30582Z"
        fill="black"
      />
    </Icon>
  )
}
